import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Grid } from '@material-ui/core';

const Calendario = ({
  mesAtual,
  setMesAtual,
  anoAtual,
  setAnoAtual,
  markedDay,
  setMarkedDay,
  diasVazios,
}) => {
  const theme = useContext(ThemeContext);

  const mesesDoAno = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ];

  const diasSemana = [
    'D','S','T','Q','Q','S', 'S'
  ]

  const styles = {
    calendar: {
      height: 'auto',
      minWidth: '357px',
      backgroundColor: `${theme.action}35`,
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Arial, sans-serif',
      borderRadius: '10.74px'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px'
    },
    button: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: '20px'
    },
    monthYear: {
      margin: '0',
      color: theme.primary
    },
    weekdays: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
      gap: '10x',
      padding: '10px',
      color: '#A2A2A2',
      fontSize: '20px'
    },
    days: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
      gap: '10px',
      padding: '10px',
      fontSize: '20px'
    },
    dayContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '33px',
      height: '30px'
    }
  };

  const diasDoMes = () => {
    const dias = [];
    const ultimoDia = new Date(anoAtual, mesAtual, 0).getDate();

    for (let dia = 1; dia <= ultimoDia; dia++) {
      dias.push(dia);
    }
    return dias;
  };

  const marcarDia = (dia) => {
    if (`${dia}-${mesAtual}-${anoAtual}` == markedDay) {
      setMarkedDay(null);
    } else {
      setMarkedDay(`${dia}-${mesAtual}-${anoAtual}`);
    }
  };

  const manipularMes = (acao) => {
    if (acao === "next") {
      if (mesAtual < 12) {
        setMesAtual(mesAtual + 1);
      } else {
        setMesAtual(1);
        setAnoAtual(anoAtual + 1);
      }
    } else if (acao === "prev") {
      if (mesAtual > 1) {
        setMesAtual(mesAtual - 1);
      } else {
        setMesAtual(12);
        setAnoAtual(anoAtual - 1);
      }
    }
  }

  return (
    <Grid container direction="column" style={styles.calendar}>
      <Grid item style={styles.header}>
        <button
          className="prev-month"
          style={styles.button}
          onClick={() => manipularMes('prev')}
        >
          &lt;
        </button>
        <h1 className="month-year" style={styles.monthYear}>
          {mesesDoAno[mesAtual - 1]}/{anoAtual}
        </h1>
        <button
          className="next-month"
          style={styles.button}
          onClick={() => manipularMes('next')}
        >
          &gt;
        </button>
      </Grid>
      <Grid item>
        <hr
          style={{
            color: 'red',
            color: '#A2A2A2',
            height: '1px',
            width: '350px'
          }}
        />
        <Grid container style={styles.weekdays}>
          {diasSemana.map(dia => (
            <Grid item container justifyContent="center">
              {dia}
            </Grid>
          ))}
        </Grid>
        <Grid container style={styles.days}>
          {diasVazios.map((_, index) => (
            <Grid
              item
              container
              justifyContent="center"
              style={{ height: '35px' }}
              key={`empty-${index}`}
            />
          ))}
          {diasDoMes().map((dia) => (
            <Grid
              item
              container
              justifyContent="center"
              style={{ height: '35px' }}
              key={dia}
            >
              <div
                style={
                  `${dia}-${mesAtual}-${anoAtual}` === markedDay
                    ? {
                        color: 'black',
                        borderRadius: '50%',
                        width: '35px',
                        height: '35px',
                        textAlign: 'center',
                        lineHeight: '30px',
                        border: `1.203px solid ${theme.primary}`,
                        background: theme.action,
                        transition: 'all 0.3s ease-in-out'
                      }
                    : null
                }
                onClick={() => marcarDia(dia)}
              >
                {dia}
              </div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Calendario;
